// "Embedded" mode: the page is shown inside the Mabrook app (legal links).
// Hides the header/footer so no subscribe/gift links appear in the app (Play policy).
// Stored for the session so internal navigation keeps the mode.
export const isEmbedded = () => {
  try {
    if (new URLSearchParams(window.location.search).get("embed") === "1") {
      sessionStorage.setItem("mabrook_embed", "1");
      return true;
    }
    return sessionStorage.getItem("mabrook_embed") === "1";
  } catch {
    return new URLSearchParams(window.location.search).get("embed") === "1";
  }
};
